 
<div class="profile-container">
  <div class="">
      <div class="profile-content">

          <div class="personal-details">

   


            <div class="header-block">
                <div class="header-title">
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                  <div class="search">
                    <form autocomplete="off" >
                      <input type="text" placeholder="search" (keyup.enter)="getProductOpeningBalanceByWildSearch(0,10)" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey">
                    </form>
                    <i class="bi bi-search" (click)="getProductOpeningBalanceByWildSearch(0,10)"></i>
                  </div>
  
                    <button *ngIf="actionControls.isAdd" title="Add" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                  <div class="filter-icon">
                    <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                  </div>
 
                </div>
              </div>
          
            <table class="table table-striped">
                <thead>
                    <tr>
              
                    <th style="width: 20%;">{{ 'product-opening-balance.productName' | translate }}</th>
                    <th style="width: 15%;">{{ 'product-opening-balance.uomName' | translate }}</th>
                    <th style="width: 20%;">{{ 'product-opening-balance.branchName' | translate }}</th>
                    <th style="width: 20%;">{{ 'product-opening-balance.openingBalance' | translate }}</th>
                    <th style="width: 15%;">{{ 'product-opening-balance.isApproved' | translate }}</th>
                    <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>

                    </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
                <div class="data-view" *ngFor="let product of ProductOpeningBalance | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }  ;let i = index">
    
                    <p style="width: 20%;">{{product.productName}}</p>
                    <p style="width: 15%;">{{product.uomName}}</p>            
                    <p style="width: 20%;">{{product.branchName}}</p>            
                    <p style="width: 20%;">{{product.openingBalance}}</p>            
                    <p style="width: 15%;">{{product.isApproved}}</p>            
                    <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                      <i *ngIf="actionControls.isView" (click)="getProductOpeningBalanceId(product.productOpeningBalanceId)" data-toggle="modal" data-target="#viewModal" class="bi bi-eye-fill"></i>
                    </p>                
                </div>
            </div>
    
    
            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>
    
            <div class="loader"  *ngIf="!isLoading && ProductOpeningBalance.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
                
            </div>
    
            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                    [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
            </div>
    
      
        </div>
      </div>
  </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Add Product Opening Balance
                <span data-dismiss="modal">
                  <i class="bi bi-x-lg"></i>
                </span>
              </h5>
          </div>
          <div class="modal-body">
              <div [formGroup]="form">
                  <div class="form-group">
                      <div class="row">
                          <div class="col-md-12 col-lg-12 product-name-list">
                              <label>Product Name</label>
                              <!-- <select class="form-control" formControlName="productName">
                                  <option *ngFor="let product of products" [value]="product.name">{{product.name}}</option>
                              </select> -->
                              <input type="text" class="form-control" (keyup)="getAllByWildSearchWithoutPagination()" formControlName="productName">
                              <div class="product-list" *ngIf="products.length != 0">
                                <p *ngFor="let product of products" (click)="selectProductName(product.name)">{{product.name}}</p>
                              </div>
                              <p class="err" *ngIf="submitted && form.get('productName').errors?.required">product name is required</p>
                          </div>
                          <div class="col-md-12 col-lg-12">
                              <label>Branch</label>
                              <select class="form-control" formControlName="branchId">
                                  <option *ngFor="let branch of branchs" [value]="branch.branchMasterId">{{branch.name}}</option>
                              </select>
                              <p class="err" *ngIf="submitted && form.get('branchId').errors?.required">branch is required</p>
                          </div>
                          <div class="col-md-12 col-lg-12">
                            <label>UOM</label>
                            <select class="form-control" formControlName="uomName" >
                              <option *ngFor="let uom of uomData" [value]="uom.uomName">{{uom.uomName}}</option>
                            </select>
                            <p class="err" *ngIf="submitted && form.get('uomName').errors?.required">uomName is required</p>
                        </div>
                          <div class="col-md-12 col-lg-12">
                              <label>Balance</label>
                              <input type="number" class="form-control" formControlName="openingBalance">
                              <p class="err" *ngIf="submitted && form.get('openingBalance').errors?.required">opening balance is required</p>
                          </div>
  
                          
                      </div>
                      <div class="modal-footer">
                          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                          <button type="button" (click)="productOpeningBalance()" class="btn btn-primary">Add</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>


<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header" *ngFor="let product of singleProductOpeningBalance">
        <h5 class="modal-title" id="exampleModalLabel">Product Opening Balance</h5>
        <!-- <span class="active">Active</span> -->
        <span class="approved" *ngIf="product.isApproved == true">Approved</span>
        <span class="not-approved" *ngIf="product.isApproved == false">Not Approved</span>


      </div>
      <div class="modal-body" *ngFor="let product of singleProductOpeningBalance">

          <div class="row">
              <div class="col-md-6 col-lg-6">
                  <label>Product Name</label>
                  <input type="text" readonly value="{{product.productName}}" class="form-control">
              </div>

              <div class="col-md-6 col-lg-6">
                  <label>Branch</label>
                  <input type="text" readonly value="{{product.branchName}}" class="form-control">
              </div>
              
              <div class="col-md-6 col-lg-6">
                  <label>Balance</label>
                  <input type="text" readonly value="{{product.openingBalance}}" class="form-control">
              </div>

              <div class="col-md-6 col-lg-6">
                  <label>Created Date</label>
                  <input type="text" readonly value="{{product.createdDate | date}}" class="form-control">
              </div>
          </div>
          <div class="status-table">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 33%;text-align: center;">User Name</th>
                    <th style="width: 33%;text-align: center;">Status</th>
                    <th style="width: 34%;text-align: center;">Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let auditList of product.auditList">
                    <td style="width: 33%;text-align: center;">{{auditList.userName}}</td>
                    <td style="width: 33%;text-align: center;">{{auditList.auditStatus}}</td>
                    <td style="width: 34%;text-align: center;">{{auditList.audiDate | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
          </div>
          <div class="modal-footer">
              <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="button" (click)="approveOpeningBalance(product.productOpeningBalanceId)" *ngIf="product.isApproved == false"  class="btn btn-primary">Approve</button>
          </div>
      </div>
    </div>
  </div>
</div>